import { path } from '~/utils/media';
import { constantCreator } from '~/utils/constantsCreator';

// const constant = constantCreator.defineAction('gallery').defineAction;
const constant = constantCreator('localTable');
const GOTO = constant('GOTO');
const NEXT = constant('NEXT');
const OPEN = constant('OPEN');
const OPEN_AND_GOTO = constant('OPEN_AND_GOTO');
const PREV = constant('PREV');
const SET = constant('SET');

const initialState = {
  isOpen: false,
  activeIndex: 0,
  items: [],
};

export default function gallery(state = initialState, action = {}) {
  switch (action.type) {
    case GOTO:
      return {
        ...state,
        activeIndex: action.index,
      };
    case NEXT:
      return {
        ...state,
        activeIndex: state.activeIndex + 1 >= state.items.length
          ? 0
          : state.activeIndex + 1,
      };
    case OPEN:
      return {
        ...state,
        isOpen: action.open,
      };
    case OPEN_AND_GOTO:
      return {
        ...state,
        isOpen: true,
        activeIndex: action.index,
      };
    case PREV:
      return {
        ...state,
        activeIndex: state.activeIndex - 1 < 0
          ? state.items.length - 1
          : state.activeIndex - 1,
      };
    case SET: // eslint-disable-line
      const images = action.images.map((image, index) => {
        return {
          ...image,
          index,
          style: path(image.image, 'gallery', true),
          thumbnailStyle: path(image.image, 'thumbnail', true),
          url: path(image.image, 'mobileGallery'),
        };
      });
      // let video = null;
      // if (action.video) {
      //   video = {
      //     index: 0,
      //     caption: '',
      //     thumbnailStyle: {
      //       backgroundImage: `url(https://img.youtube.com/vi/${action.video}/0.jpg)`,
      //     },
      //     style: {
      //       backgroundImage: `url(https://img.youtube.com/vi/${action.video}/0.jpg)`,
      //     },
      //     url: `https://img.youtube.com/vi/${action.video}/0.jpg`,
      //     video: `https://www.youtube.com/embed/${action.video}?autoplay=1`,
      //   };
      // }
      return {
        ...state,
        items: images,
      };
    default:
      return state;
  }
}

export const actions = {
  goTo: index => ({
    type: GOTO,
    index,
  }),
  next: () => ({
    type: NEXT,
  }),
  openGalleryLocalTable: (open = true) => ({
    type: OPEN,
    open,
  }),
  openAndGoToGalleryLocalTable: index => ({
    type: OPEN_AND_GOTO,
    index,
  }),
  prev: () => ({
    type: PREV,
  }),
  setItems: (images) => ({
    type: SET,
    images,
  }),
};
